// extracted by mini-css-extract-plugin
module.exports = {"hiddenCheckbox":"Checkbox_hiddenCheckbox__31z31","checkbox":"Checkbox_checkbox__1wVDV"};